import { SET_CODE, TOGGLE_MENU } from "../constants";

const setCode = code => ({
  type: SET_CODE,
  code
});

const resetCode = () => ({
  type: SET_CODE,
  code: null
});

const toggleMenu = visible => ({
  type: TOGGLE_MENU,
  visible
});

export { setCode, resetCode, toggleMenu };



// WEBPACK FOOTER //
// ./src/actions/index.js